export const environment = {
  name: 'deploy',
  production: true
};
